export default {"src":"/_next/static/media/icon_x_gradient_background.0e3e76e9.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};